// Libs
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Hooks
import useAuthRedirect from '@app/hooks/useAuthRedirect';

// Constants
import { PAGE_URL } from '@app/constants/route';

//Styles
import './Auth.scss';

const Auth = () => {
  // Đã đăng nhập (có token) → vào thẳng Owner Dashboard (route mặc định của DiOwner).
  useAuthRedirect(PAGE_URL.OWNER_DASHBOARD);
  const { t } = useTranslation();

  return (
    <div className="auth">
      <Outlet />
    </div>
  );
};

export default Auth;
